export const MAX_FILE_MB = 100
const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export interface FlattenPdfResult {
  blob: Blob
  totalPages: number
  fieldCount: number
  hasXfa: boolean
}

export function validateFileSize(file: File): boolean {
  return file.size <= MAX_FILE_BYTES
}

export function flattenedFilename(originalName: string): string {
  const dotIndex = originalName.lastIndexOf('.')
  const base = dotIndex !== -1 ? originalName.slice(0, dotIndex) : originalName
  return `${base}-flattened.pdf`
}

export async function flattenPdfFormFields(file: File): Promise<FlattenPdfResult> {
  const { PDFDocument } = await import('pdf-lib')
  const bytes = await file.arrayBuffer()
  const pdfDoc = await PDFDocument.load(bytes)
  const form = pdfDoc.getForm()
  const fields = form.getFields()
  const hasXfa = form.hasXFA()

  form.flatten()

  const out = await pdfDoc.save()
  return {
    blob: new Blob([out], { type: 'application/pdf' }),
    totalPages: pdfDoc.getPageCount(),
    fieldCount: fields.length,
    hasXfa,
  }
}
